import { api } from '../api/client';

/*
 * THE ROUND IS REGISTERED BEFORE THE LEARNER SEES IT.
 *
 * A sequence and a timed hold are built here rather than on the server, because
 * what they present cannot be derived from a word pool. That is not the same as
 * marking our own work: the trial is registered with what will be shown and what
 * would be correct, and the verdict comes back from the server, judged against
 * what it stored. Registering afterwards would let the answer be chosen to match
 * whatever the learner happened to do.
 */

export type RegisteredTrial = { trialId: string };

export type TrialVerdict = {
  correct: boolean;
  complete: boolean;
  attempts: number;
  /** How much this response earned, if the every-N rule came due on it. */
  rewarded: number;
};

/** Items are joined with a character no prompt would contain. */
export const ORDER_SEPARATOR = '';

export async function registerTrial(
  programId: string,
  learnerId: string | undefined,
  presented: Record<string, unknown>,
  answer: Record<string, unknown> | null,
): Promise<RegisteredTrial> {
  return api<RegisteredTrial>('/trials', {
    method: 'POST',
    token: true,
    body: { programId, learnerId, presented, answer },
  });
}

export async function respondTrial(trialId: string, response: string): Promise<TrialVerdict> {
  return api<TrialVerdict>(`/trials/${trialId}/response`, {
    method: 'POST',
    token: true,
    body: { response },
  });
}
